const Welcome = () => {
  return (
    <section className="py-16 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-6">
          Welcome to Oloid Developer Portal
        </h1>
        {/* <p className="text-lg text-muted-foreground mb-12">
          Explore our powerful identity and access management platform APIs and
          stay updated with our latest releases.
        </p> */}

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="border rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-4">API Reference</h2>
            <p className="text-muted-foreground mb-6">
              Discover our comprehensive APIs to integrate with your systems
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-between p-3 border rounded">
                <span>Authentication API</span>
                <a
                  href="/api/auth"
                  className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
                >
                  Explore
                </a>
              </div>
              <div className="flex items-center justify-between p-3 border rounded">
                <span>Users API</span>
                <a
                  href="/api/users"
                  className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
                >
                  Explore
                </a>
              </div>
              <div className="flex items-center justify-between p-3 border rounded">
                <span>Groups API</span>
                <a
                  href="/api/groups"
                  className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
                >
                  Explore
                </a>
              </div>
            </div>
            <a
              href="/introduction"
              className="inline-flex items-center justify-center w-full py-3 border border-input rounded hover:bg-accent hover:text-accent-foreground transition-colors"
            >
              View All APIs
            </a>
          </div>

          <div className="border rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-4">Release Notes</h2>
            <p className="text-muted-foreground mb-6">
              Stay updated with our latest platform and app releases
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-between p-3 border rounded">
                <span>Platform Updates</span>
                <a
                  href="/changelog/platform"
                  className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
                >
                  View
                </a>
              </div>
              <div className="flex items-center justify-between p-3 border rounded">
                <span>iOS App</span>
                <a
                  href="/changelog/ios"
                  className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
                >
                  View
                </a>
              </div>
              <div className="flex items-center justify-between p-3 border rounded">
                <span>Windows App</span>
                <a
                  href="/changelog/windows"
                  className="inline-flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
                >
                  View
                </a>
              </div>
            </div>
            <a
              href="/changelog/platform"
              className="inline-flex items-center justify-center w-full py-3 border border-input rounded hover:bg-accent hover:text-accent-foreground transition-colors"
            >
              View All Releases
            </a>
          </div>
        </div>

        {/* <div className="flex justify-center gap-4">
          <a
            href="https://www.oloid.com/"
            target="_blank"
            className="inline-flex items-center justify-center px-8 py-3 border border-input rounded-lg hover:bg-accent hover:text-accent-foreground transition-colors"
          >
            Learn More About Oloid
          </a>
          <a
            href="/introduction"
            className="inline-flex items-center justify-center px-8 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
          >
            Get Started
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default Welcome;
